export default __webpack_public_path__ + "static/media/earning.e73a29ae.svg";